// MM/DD/YYYY, M/D/YYYY
// const DATE_REGEX = new RegExp(/^(\d{2}|\d{1})\/(\d{2}|\d{1})\/\d{4}$/);
const DATE_REGEX = new RegExp(/^\d{4}\-(\d{2})\-(\d{2})$/);

export { DATE_REGEX };
